<template>
    <div class="template-static">
        <slot name="header"></slot>
        <main>
            <div class="container" v-if="showInfoArea">
                <div class="info-area">
                    <slot name="info-area">
                    </slot>
                </div>
            </div>
            <div class="container">
                <slot></slot>
            </div>
        </main>
        <footer>
            <slot name="footer">
                <Footer/>
            </slot>
        </footer>
    </div>
</template>

<script>
import Footer from './common/Footer'
import Header from './static/Header'
export default {
  name: 'StaticLayout',
  components: {Header, Footer},
  computed: {
    showInfoArea: function () {
      return this.$slots['info-area']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/StaticLayout.vue